import axios from "axios";
import { authHeaders } from "./apiToken";

export const purchaseAPI = async (
    body: string | object,
    action: string,
    userEmail: string
  ) => {
    const url = "https://process-api-01.azure-api.net/purchasing/manual/paths/invoke";
  
    const data = {
        body: body,
        action: action,
        userEmail: userEmail
    }

    try {
      const config = { headers: await authHeaders() };
      const response = await axios.post(url, data, config);
      return response;

    } catch (error) {
      console.error("API request failed:", error);
    }
  };

